import React, { useEffect, useState } from "react";
import Chip from "@mui/material/Chip";
import { Box, DialogContent } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Stack from "@mui/material/Stack";
import ReservationStatusChip from "./ReservationStatusChip";
import { getData, postData } from "../api/AuthenticatedApiCaller";
import { ReservationApi } from "../api/AdminApi";

export default function ReservationStatusDialog({
  isOpen,
  close,
  referenceNumber,
  onComplete,
}) {
  async function completeReservation() {
    await postData(
      ReservationApi.completeReservation + "?referenceNumber=" + referenceNumber
    ).then(() => {
      onComplete();
    });
  }

  async function cancelReservation() {
    await postData(
      ReservationApi.cancelReservation + "?referenceNumber=" + referenceNumber
    ).then(() => {
      onComplete();
    });
  }

  return (
    <Dialog open={isOpen} onClose={close}>
      <DialogTitle>
        Select new Reservation Status for {referenceNumber}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={0.8}>
          <ReservationStatusChip
            status="COMPLETE"
            onClick={completeReservation}
          />
          <ReservationStatusChip status="CANCEL" onClick={cancelReservation} />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
